import { Fancybox } from "@fancyapps/ui";
import "../_plugins/@master/css";
import "./modules/Header";
import "./modules/Slider";
import "./modules/Accordion";
import "./modules/BackToTop";
import "./modules/Home";
import "./modules/ExpandContent";
import "./modules/ProductDetail";
import "./modules/Dealer";
import "./modules/MissPc";

var lazyLoadInstance = new LazyLoad({
	// Your custom settings go here
});

window.lazyLoadInstance = lazyLoadInstance;

Fancybox.bind("[data-fancybox]", {
	// Your custom options
	Thumbs: false,
});

$(function () {
	$(".has-sub-link .btn-icon").on("click", function (e) {
		e.preventDefault();
		$(this).find("span").toggleClass("fa-facebook-f fa-xmark fab fal");
		$(this).next().slideToggle();
	});

	$(".copy-link").on("click", function (e) {
		e.preventDefault();
		copyURLToClipboard();
		$(".copy-alert").fadeIn();
		setTimeout(() => {
			$(".copy-alert").fadeOut();
		}, 2000);
	});

	$(".news-detail-content img").each(function (index, element) {
		let _this = $(element);
		let caption = _this.attr("title");
		if (caption) {
			let figure = $("<figure></figure>");
			_this.wrap(figure);

			let figcaption = $(`<figcaption>${caption}</figcaption>`);
			figcaption.insertAfter(_this);
		}
	});

	// window.addEventListener("hashchange", adjustScrollPosition);

	// function adjustScrollPosition() {
	// 	const headerHeight =
	// 		document.querySelector(".global-header").offsetHeight; // Replace '.header' with your header selector
	// 	const element = document.getElementById(location.hash.substring(1));
	// 	if (element) {
	// 		window.scrollTo({
	// 			top: element.offsetTop - headerHeight,
	// 			// behavior: "smooth",
	// 		});
	// 		$(".global-menu").toggleClass("show");
	// 		$("body").toggleClass("overflow-hidden");
	// 		$(this).find("span").toggleClass("fa-bars fa-xmark");
	// 	}
	// }

	$(".training-item-content").matchHeight();
	$(".training-item-brief").matchHeight();
	$(".training-item-deadline").matchHeight();
});

function copyURLToClipboard() {
	const textArea = document.createElement("textarea");
	textArea.value = window.location.href;
	document.body.appendChild(textArea);
	textArea.select();
	document.execCommand("copy");
	document.body.removeChild(textArea);
}
